'use strict';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
/**
 * Module dependencies.
 */
var bindAll = require('bind-all');
var cookie = require('@segment/cookie');
var debug = require('debug')('analytics.js:cookie');
var topDomain = require('@segment/top-domain');
var MAX_AGE_ONE_YEAR = 31536000000;
/**
 * Initialize a new `Cookie` with `options`.
 *
 * @param {Object} options
 */
function Cookie(options) {
    this.options(options);
}
/**
 * Get or set the cookie options.
 */
Cookie.prototype.options = function (options) {
    if (arguments.length === 0)
        return this._options;
    options = options || {};
    var domain = '.' + topDomain(window.location.href);
    if (domain === '.')
        domain = null;
    var defaults = {
        maxage: MAX_AGE_ONE_YEAR,
        domain: domain,
        path: '/',
        sameSite: 'Lax'
    };
    this._options = __assign(__assign({}, defaults), options);
    // http://curl.haxx.se/rfc/cookie_spec.html
    // https://publicsuffix.org/list/effective_tld_names.dat
    //
    // try setting a dummy cookie with the options
    // if the cookie isn't set, it probably means
    // that the domain is on the public suffix list
    // like myapp.herokuapp.com or localhost / ip.
    this.set('ajs:test', true);
    if (!this.get('ajs:test')) {
        debug('fallback to domain=null');
        this._options.domain = null;
    }
    this.remove('ajs:test');
};
/**
 * Set a `key` and `value` in our cookie.
 */
Cookie.prototype.set = function (key, value) {
    try {
        value = window.JSON.stringify(value);
        cookie(key, value === 'null' ? null : value, lodash_clonedeep_1.default(this._options));
        return true;
    }
    catch (e) {
        return false;
    }
};
/**
 * Get a value from our cookie by `key`.
 */
Cookie.prototype.get = function (key) {
    try {
        var value = cookie(key);
        value = value ? window.JSON.parse(value) : null;
        return value;
    }
    catch (e) {
        return null;
    }
};
/**
 * Remove a value from our cookie by `key`.
 */
Cookie.prototype.remove = function (key) {
    try {
        cookie(key, null, lodash_clonedeep_1.default(this._options));
        return true;
    }
    catch (e) {
        return false;
    }
};
/**
 * Expose the cookie singleton.
 */
module.exports = bindAll(new Cookie());
/**
 * Expose the `Cookie` constructor.
 */
module.exports.Cookie = Cookie;



//////////////////
// WEBPACK FOOTER
// ./~/@segment/analytics.js-core/build/cookie.js
// module id = 259
// module chunks = 0